/** Default visible columns in left-to-right display order (schema order matches). */
export const INVITATION_MAILS_TABLE_DEFAULT_VISIBLE_KEYS = [
  'type',
  'accepter_email',
  'requestor_email',
  'name',
  'n_building',
  'updatedAt',
  'status',
  'resend_invite',
  'actions',
];

/** Invitation statuses that allow resending. */
export const RESENDABLE_INVITATION_STATUSES = ['expired', 'pending', 'declined'];

export const canResendInvitation = (status) => RESENDABLE_INVITATION_STATUSES.includes(status);

/** Bump when default columns/order change so persisted prefs reset. */
export const INVITATION_MAILS_TABLE_STORAGE_KEY = 'invitation-mails-list-v1';
